import moment from "moment";
import axios from "axios";
import auth from "../../utils/auth";

const state = {
	list: [],
	optedInPromo: localStorage.getItem("btk-promo")
		? JSON.parse(localStorage.getItem("btk-promo"))
		: [],
};

const persistPromo = (optedInPromo) => {
	localStorage.setItem("btk-promo", JSON.stringify(optedInPromo));
};

const getters = {
	list: (state) => state.list,
	optedInPromo: (state) => state.optedInPromo,
};
const mutations = {
	FETCH_PROMOS(state, list) {
		state.list = list;
	},
	SET_OPTED_IN_PROMO(state, optedInPromo) {
		let optedInPromos = state.optedInPromo;
		optedInPromos.push(optedInPromo);

		state.optedInPromo = optedInPromos;
		persistPromo(optedInPromos);
	},
};
const actions = {
	async getPromos({ commit, dispatch }) {
		try {
			if(PROMOS_API_URL !== null){
				const token = auth.getToken();
				let req = {
					url: `${PROMOS_API_URL}offers`,
					method: "GET",
					data: {},
				};
				if (token) {
					req.url = `${PROMOS_API_URL}offers/profile`;
					req.method = "POST";
					req.data.token = token;
				}
	
				const data = await axios(req);
	
				let promos = data.data;
				let mappedPromos = promos.map(function(promo) {
					// Get filtered promos
					return {
						promoCategory: {
							category_id: promo.category.category_id,
							category_name: promo.category.category_name,
							description: promo.category.description,
							status: promo.category.status,
							promo_type: "dynamic",
						},
						promoData: {
							promos_id: promo.promos_id,
							promo_name: promo.promo_name,
							description: promo.description,
							image_url: promo.image_url,
							start_time: promo.start_time,
							end_time: promo.end_time,
							status: promo.status,
							category_id: promo.category_id,
							award: {
								promos_award_id: promo.award.promos_award_id,
								promos_id: promo.award.promos_id,
								amount: promo.award.amount,
								status: promo.award.status,
							},
							rules: promo.rules,
							opted_in: promo.opted_in,
							reference: promo.reference,
						},
					};
				});

				// Remove UI optins that are either already opted in or expired
				mappedPromos.forEach((promo) => {
				const expired = moment(promo.promoData.end_time).isBefore(new Date());
				if (expired || promo.promoData.opted_in) {
					dispatch("optOutPromo", promo.promoData.promos_id);
				}
				});

				const mergedPromos = Object.values(
					mappedPromos.reduce(
						(a, { promoCategory, promoData }) => (
							(a[promoCategory.category_id] = a[promoCategory.category_id] || {
								promoCategory,
								promoData: [],
							})["promoData"].push(promoData),
							a
						),
						{}
					)
				);
	
				commit("FETCH_PROMOS", mergedPromos);
			} else {
				commit("FETCH_PROMOS", []);
			}
		} catch (error) {
			commit("FETCH_PROMOS", []);
		}
	},
	optInPromo({ commit }, promo) {
		//change to optedInPromo
		promo.promo_id = promo.promos_id;

		commit("SET_OPTED_IN_PROMO", promo);
	},
	optOutPromo({ commit, state }, promoOutId) {
		// promoOut
		const arr = state.optedInPromo.filter(
			(item) => item.promo_id !== promoOutId
		);
		state.optedInPromo = arr;

		// persist btk-promo
		localStorage.setItem("btk-promo", JSON.stringify(state.optedInPromo));
	},
	optOutAllPromos({ commit, state }) {
		state.optedInPromo = [];
		localStorage.setItem("btk-promo", JSON.stringify([]));
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
